import { render, staticRenderFns } from "./ModalPrompt.vue?vue&type=template&id=7a67b6a0&"
import script from "./ModalPrompt.vue?vue&type=script&lang=js&"
export * from "./ModalPrompt.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrompt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports